// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type ScorecardStatus = "pass" | "warn" | "fail" | "info" | "skip";

const STATUS_COLORS: Record<ScorecardStatus, string> = {
  pass: "bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-900",
  warn: "bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  fail: "bg-red-100 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900",
  info: "bg-blue-100 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
  skip: "bg-zinc-100 text-zinc-600 border-zinc-200 dark:bg-zinc-900 dark:text-zinc-400 dark:border-zinc-800",
};

interface ScorecardStatusBadgeProps {
  status: ScorecardStatus;
  className?: string;
}

export function ScorecardStatusBadge({ status, className }: ScorecardStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      variant="outline"
      className={cn("font-normal text-xs", STATUS_COLORS[status] ?? STATUS_COLORS.skip, className)}
    >
      {t(`storeScorecard.status.${status}`)}
    </Badge>
  );
}
